import React, { useEffect } from "react";
import { KJUR } from "jsrsasign";
import { useAppConfig } from "../../api/useAppConfig";

export const ZendeskWidget = ({ enabled = false }) => {
  const { config, loading, error } = useAppConfig();

  const generateJwt = () => {
    if (!config) return "";
    const header = { alg: "HS256", typ: "JWT" };
    const payload = {
      name: config.serviceName,
      email: config.serviceEmail,
      iat: Math.floor(Date.now() / 1000),
      jti: Date.now().toString(),
    };
    return KJUR.jws.JWS.sign("HS256", JSON.stringify(header), JSON.stringify(payload), {
      rstr: config.sharedSecret,
    });
  };

  const loadWidget = (jwt) => {
    // ⚠️ 先设置 window.zESettings，再注入脚本
    window.zESettings = {
      webWidget: {
        authenticate: {
          jwtFn: (callback) => callback(jwt),
        },
        helpCenter: {
          suppress: false,
          originalArticleButton: false,
          chatButton: { "*": "Chat with us" },
          messageButton: { "*": "Leave us a message" },
        },
        answerBot: {
          avatar: {
            url: "https://addon.matteroom.com/assets/manifest/prime_logo_80px.png",
            name: { "*": "Matteroom" },
          },
          title: { "*": "Chat with us!" },
          suppress: false,
        },
      },
    };

    // 再注入 Zendesk 脚本（避免重复加载）
    if (!document.getElementById("ze-snippet")) {
      (function (w, d, s, id, src, js, fjs) {
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = src;
        js.async = true;
        fjs = d.getElementsByTagName(s)[0];
        fjs.parentNode.insertBefore(js, fjs);
      })(window, document, "script", "ze-snippet", config.serviceUrl);
    }
  };

  useEffect(() => {
    if (!loading && !error && config) {
      const jwt = generateJwt();
      loadWidget(jwt);
    }
  }, [loading, error, config]);

  useEffect(() => {
    if (enabled) {
      const style = document.getElementById("hide-zendesk-style");
      if (style) style.remove();
      if (typeof window.zE === "function") {
        window.zE("messenger", "show");
      }
    } else {
      if (!document.getElementById("hide-zendesk-style")) {
        const style = document.createElement("style");
        style.id = "hide-zendesk-style";
        style.innerHTML = `
          iframe#launcher,
          iframe[src*="web-widget"] { display: none !important; }
        `;
        document.head.appendChild(style);
      }
      if (typeof window.zE === "function") {
        window.zE("messenger", "hide");
        window.zE("messenger", "close");
      }
    }
  }, [enabled]);

  return null;
};
